import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import type { Trailer } from "../../store/admin/trailersStore";

export interface TrailerListParams {
  page?: number;
  limit?: number;
  status_id?: string;
  type?: string;
  search?: string;
}

interface ListMeta {
  error: string | null;
  count: number;
  status: number;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  url: string;
}

interface TrailerListBody {
  data?: Trailer[];
  meta?: ListMeta;
}

export interface TrailerListResult {
  data: Trailer[];
  meta?: ListMeta;
}

export function useTrailersList(params: TrailerListParams = {}) {
  const cid = useCompaniesStore((s) => s.companyId);
  return useQuery({
    queryKey: qk.trailers.list(cid, params),
    queryFn: ({ signal }) =>
      getJson<TrailerListBody>(
        "/remolquesList",
        { page: 1, limit: 8, ...params },
        { signal },
      ).then((body) => ({ data: body.data ?? [], meta: body.meta })),
  });
}
